<div class="shell antialiased" [class.sidebar-collapsed]="sidebarCollapsed()">
  <aside [class.open]="menu()">
    <button
      class="mobile-sidebar-close size-9 items-center justify-center rounded-lg border border-blue-200 bg-white text-slate-700 shadow-sm transition-colors hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400"
      type="button"
      (click)="menu.set(false)"
      aria-label="ปิดเมนู"
    >
      <lucide-icon name="X" [size]="20" aria-hidden="true" />
    </button>
    <div class="brand">
      <span>AT</span>
      <div>ALL TO TRIPS<small>ระบบจัดการหลังบ้าน</small></div>
    </div>
    <nav>
      @for (section of visibleMenuSections(); track section.title) {
        <section class="menu-section">
          <p class="menu-section-title">
            {{ section.title }}
          </p>

          @for (item of section.items; track item.path) {
            <a
              [routerLink]="item.path"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [attr.title]="sidebarCollapsed() ? item.label : null"
              (click)="menu.set(false)"
            >
              <lucide-icon [name]="item.icon" [size]="18" aria-hidden="true" />

              <span class="side-label">{{ item.label }}</span>
            </a>
          }
        </section>
      }
    </nav>
    <div class="side-foot">
      <button
        type="button"
        class="flex w-full items-center justify-center gap-2 rounded-lg bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        aria-label="ออกจากระบบ"
        [attr.title]="sidebarCollapsed() ? 'ออกจากระบบ' : null"
        (click)="confirmLogout()"
      >
        <lucide-icon name="LogOut" [size]="17" aria-hidden="true" />
        <span class="side-label">ออกจากระบบ</span>
      </button>
      <p class="mb-0 text-center text-blue-500/70"> เวอร์ชัน {{ appVersion }}</p>
    </div>
  </aside>
  @if (menu()) {
    <button class="scrim" (click)="menu.set(false)" aria-label="ปิดเมนู"></button>
  }
  <main>
    <header>
      <button
        class="desktop-sidebar-toggle"
        type="button"
        (click)="sidebarCollapsed.set(!sidebarCollapsed())"
        [attr.aria-label]="sidebarCollapsed() ? 'ขยายเมนูด้านข้าง' : 'ย่อเมนูด้านข้าง'"
      >
        <lucide-icon
          [name]="sidebarCollapsed() ? 'TextAlignStart' : 'TextAlignEnd'"
          [size]="20"
          aria-hidden="true"
        />
      </button>
      <button
        class="menu-btn size-10 items-center justify-center rounded-xl border border-blue-200 bg-white text-slate-700 shadow-sm transition-colors hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400"
        (click)="menu.set(!menu())"
        aria-label="เปิดหรือปิดเมนู"
      >
        <lucide-icon name="Menu" [size]="22" aria-hidden="true" />
      </button>
      <div>
        <strong>ระบบบริหารงานทัวร์</strong><small>จัดการข้อมูลอย่างเป็นระบบในที่เดียว</small>
      </div>
      <div class="profile">
        <span>{{ initials() }}</span>
        <div>
          {{ auth.user()?.firstName }} {{ auth.user()?.lastName }}
          <small>
            {{ auth.user()?.department?.name }} · {{ auth.user()?.role?.name }}
          </small>
        </div>
      </div>
    </header>
    <section class="content"><router-outlet /></section>
  </main>
</div>
